/* eslint-disable react/prop-types */
import { useDispatch } from "react-redux";
import type ConstructionListItem from "../../types/ConstructionListItem";
import type IPagination from "../../types/IPagination";
import { useNavigate } from "react-router-dom";
import { changePage, sort } from "../../constructionsNewSlice";
import PathConstants from "../../../../routes/pathConstants";
import useConstructionsNewTableSelectionHook from "./hooks/useConstructionsNewTableSelectionHook";
import useConstructionsNewTableColumns from "./hooks/useConstructionsNewTableColumns";
import { SelectionMode, ShimmeredDetailsList } from "@fluentui/react";
import IsaacEmpty from "../../../../components/isaacEmpty/IsaacEmpty";
import ConstructionsNewPagination from "../pagination/ConstructionsNewPagination";

interface ConstructionsNewTableProps {
    handleSelection: (selectedConstructions: ConstructionListItem[]) => void;
    loading: boolean;
    page: ConstructionListItem[];
    pagination: IPagination;
}

const ConstructionsNewTable: React.FunctionComponent<ConstructionsNewTableProps> = ({
    handleSelection,
    loading,
    page,
    pagination,
}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleSorting = (
        columnName: keyof ConstructionListItem, 
        isSortedDescending: boolean
    ): void => {
        dispatch(sort({ columnName, isSortedDescending }));
    };

    const handleConstructionSelection = (selectedConstructions: ConstructionListItem[]): void => {
        handleSelection(selectedConstructions);
    };

    const handleItemInvoke = (item: ConstructionListItem): void => {
        void navigate(`${PathConstants.Constructions}/${item.id}`);
    };

    const selection = useConstructionsNewTableSelectionHook(handleConstructionSelection);
    const columns = useConstructionsNewTableColumns(handleSorting);

    return (
        <>
          <ShimmeredDetailsList
            enableShimmer={loading}
            isSelectedOnFocus={true}
            enableUpdateAnimations={true}
            onShouldVirtualize={() => true}
            items={page}
            columns={columns}
            setKey="set"
            selection={selection}
            selectionPreservedOnEmptyClick={true}
            ariaLabelForSelectionColumn="Toggle selection"
            ariaLabelForSelectAllCheckbox="Toggle selection for all items"
            listProps={{
              renderedWindowsAhead: 0,
              renderedWindowsBehind: 0,
            }}
            selectionMode={SelectionMode.multiple}
            onItemInvoked={handleItemInvoke}
          />
    
          {page?.length <= 0 && !loading && (
            <IsaacEmpty message="There are no constructions yet..." />
          )}
    
          {page?.length > 0 && (
            <ConstructionsNewPagination
              handlePageChange={(pageNumber: number) => {
                dispatch(changePage(pageNumber));
              }}
              pagination={pagination}
            />
          )}
        </>
      );
};

export default ConstructionsNewTable;

